import { createSlice } from "@reduxjs/toolkit";

const actionSlice = createSlice({
  name: "action",
  initialState: {
    smallSidebarWidth: false,
    smallSidebarProfileWidth: false,
    focused: [],
    open: false,
    mess: "",
    loading:false,
  },
  reducers: {
    setSidebarWidth(state, action) {
      state.smallSidebarWidth = action.payload;
    },
    setSidebarProfileWidth(state, action) {
      state.smallSidebarProfileWidth = action.payload;
    },
    setFocused(state, action) {
      state.focused = action.payload;
    },
    setOpenAlert(state, action) {
      state.open = action.payload;
    },
    setMessAlert(state, action) {
      state.mess = action.payload;
    },
    setLoadingMain(state, action) {
      state.loading = action.payload;
    },
  },
});

export const {
  setSidebarWidth,
  setSidebarProfileWidth,
  setFocused,
  setOpenAlert,
  setMessAlert,
  setLoadingMain
} = actionSlice.actions;
export default actionSlice.reducer;
